import { render, staticRenderFns } from "./BaseCheckoutCardGroup.vue?vue&type=template&id=08dcf48a"
import script from "./BaseCheckoutCardGroup.vue?vue&type=script&lang=js"
export * from "./BaseCheckoutCardGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports